// Package imports
import React from "react";
import { Box } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const StatusIndicator = (props) => {
  return (
    <Box sx={{alignSelf: 'center', display: 'inline-flex'}}>
      {props && props.correct && (
        <CheckCircleIcon
          sx={{
            borderRadius: "50%",
            color:'#22a014',
            "@media (min-width: 1636px)": {
              fontSize: "2.2rem",
            },
          }}
        />
      )}
      {props && !props.correct && (
        <CancelIcon
          sx={{
            borderRadius: "50%",
            color:'red',
            "@media (min-width: 1636px)": {
              fontSize: "2.2rem",
            },
          }}
        />
      )}
    </Box>
  );
};

export default StatusIndicator;
